var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 63,
    viewBox: "0 0 16 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.27 0.0774993V24.3875C14.27 26.9942 14.1142 29.5867 13.8025 32.165C13.4908 34.715 13.08 37.3217 12.57 39.985H3.645C3.135 37.3217 2.72417 34.715 2.4125 32.165C2.10083 29.5867 1.945 26.9942 1.945 24.3875V0.0774993H14.27ZM0.5 55.3275C0.5 54.3075 0.684167 53.3583 1.0525 52.48C1.44917 51.6017 1.97333 50.8367 2.625 50.185C3.305 49.5333 4.09833 49.0233 5.005 48.655C5.91167 48.2583 6.90333 48.06 7.98 48.06C9.02833 48.06 10.0058 48.2583 10.9125 48.655C11.8192 49.0233 12.6125 49.5333 13.2925 50.185C13.9725 50.8367 14.4967 51.6017 14.865 52.48C15.2617 53.3583 15.46 54.3075 15.46 55.3275C15.46 56.3475 15.2617 57.3108 14.865 58.2175C14.4967 59.0958 13.9725 59.8608 13.2925 60.5125C12.6125 61.1642 11.8192 61.6742 10.9125 62.0425C10.0058 62.4108 9.02833 62.595 7.98 62.595C6.90333 62.595 5.91167 62.4108 5.005 62.0425C4.09833 61.6742 3.305 61.1642 2.625 60.5125C1.97333 59.8608 1.44917 59.0958 1.0525 58.2175C0.684167 57.3108 0.5 56.3475 0.5 55.3275Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.7d25ed5312b04a8445c798b03571caa8.svg";
export { ForwardRef as ReactComponent };